<template>
  <div class="flex flex-col relative items-center justify-start pt-2 h-[400px] overflow-auto">
    <div class="flex flex-col items-center w-full space-y-5">
      <div class="flex justify-between w-full gap-2">
        <TextInput
          v-model="current_metric.name"
          :value="current_metric.name"
          name="name"
          type="text"
          :validate-on-input="true"
          :label="$t('Metric name')"
          :info-message="current_metric.id ? `reference: ${current_metric.reference_name}` : ''"
          :placeholder="$t('Metric Name')" />
        <!--   <ComboBoxInput
          v-model:current-item="current_metric.metric_tag"
          :items="$store.state.data.metrics_tags"
          name="metric_tag"
          classes="w-1/3 relative dark:text-white"
          label-attr="label"
          value-attr="value"
          :is-box-background="true"
          :label="$t('Metric Tag')"
          :show-label="true"
          :floating-label="true"
          :allow-null="true" /> -->
      </div>

      <ComboBoxInput
        v-model:current-item="current_metric.object_type"
        :items="$store.state.object_types"
        name="object_type"
        classes="w-full relative dark:text-white"
        label-attr="label"
        value-attr="type"
        :is-box-background="true"
        :label="$t('Object Type')"
        :show-label="true"
        :floating-label="false"
        :allow-null="false" />

      <TextArea
        v-model="current_metric.description"
        :tooltip-info="$t('Enter description here')"
        :value="current_metric.description"
        name="description"
        classes="bg-light-box-background dark:bg-dark-box-background"
        :validate-on-input="true"
        type="text"
        :label="$t('Description')" />
    </div>
  </div>
</template>

<script>
import TextInput from "@/components/shared/TextInput.vue"
import TextArea from "@/components/shared/TextArea.vue"
import ComboBoxInput from "@/components/shared/ComboBoxInput.vue"
import dataService from "@/services/data.service"

// import { Formulary } from "@/models/metric"

export default {
  components: {
    ComboBoxInput,
    TextInput,
    TextArea
  },
  props: {
    metric: {
      type: Object,
      required: true
    }
  },
  emits: ["update"],
  data() {
    return {
      setFormulaErrors: () => {},
      is_not_empty_formula: false,
      is_formula_valid: false,
      current_metric: null
    }
  },

  watch: {
    "current_metric.name": {
      deep: true,
      handler() {
        this.$utils.debounce(() => {
          this.$emit("update", this.current_metric)
        }, 200)
      }
    },
    "current_metric.metric_tag": {
      deep: true,
      handler() {
        this.$utils.debounce(() => {
          this.$emit("update", this.current_metric)
        }, 200)
      }
    },
    "current_metric.object_type": {
      deep: true,
      handler() {
        this.$utils.debounce(() => {
          this.$emit("update", this.current_metric)
        }, 200)
      }
    },
    "current_metric.description": {
      deep: true,
      handler() {
        this.$utils.debounce(() => {
          this.$emit("update", this.current_metric)
        }, 200)
      }
    },
    "current_metric.formulary": {
      deep: true,
      handler() {
        this.$utils.debounce(() => {
          if (this.current_metric) {
            this.$emit("update", this.current_metric)
            if (this.current_metric.formulary?.expression) {
              this.is_not_empty_formula = this.current_metric.formulary?.expression?.length > 0
            } else if (this.current_metric.formulary?.cases?.length > 0) {
              this.is_not_empty_formula = this.current_metric.formulary?.cases[0]["when"].length > 0
            } else {
              this.is_not_empty_formula = false
            }
            dataService
              .isFormulaValid(this.current_metric)
              .then((res) => {
                this.is_formula_valid = res.data.status == "FORMULA_IS_VALID"
                if (this.is_formula_valid && this.is_not_empty_formula) {
                  this.setFormulaErrors()
                } else {
                  this.setFormulaErrors(this.$t("Formula is not Valid"))
                }
              })
              .catch(() => {
                this.setFormulaErrors(this.$t("Formula is not Valid"))
                this.is_formula_valid = false
              })
          }
        }, 200)
      }
    }
  },

  created() {
    this.current_metric = this.$utils.clone(this.metric)
  },

  methods: {
    // onFormulaChanged($event, handleChange, setErrors) {
    //   this.setFormulaErrors = setErrors
    //   this.current_metric.formulary = $event
    // }
  }
}
</script>
